import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DisclaimerService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getDisclaimer(scope = 'backoffice'): Observable<any> {
    return this.http.get(environment.apiUrl + '/' + scope + '/disclaimer/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDisclaimerBackoffice(): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/disclaimer/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public showDisclaimer(id): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/disclaimer/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public createDisclaimer(data) {
    return this.http.post(environment.apiUrl + '/backoffice/disclaimer/', data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public updateDisclaimer(data, id) {
    return this.http.put(environment.apiUrl + '/backoffice/disclaimer/' + id, data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  removeDisclaimer(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/disclaimer/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
